import { render, staticRenderFns } from "./OrientationMessage.vue?vue&type=template&id=47d208a6&scoped=true&"
import script from "./OrientationMessage.vue?vue&type=script&lang=js&"
export * from "./OrientationMessage.vue?vue&type=script&lang=js&"
import style0 from "./OrientationMessage.vue?vue&type=style&index=0&id=47d208a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d208a6",
  null
  
)

export default component.exports